Promise.all([import('scripts/marmalade/classes/image-normalizer')]).then(_ref => {
  let [moduleNormalizer] = _ref;
  // Define the components
  const ImageNormalizerController = moduleNormalizer.default;
  DomObserver.observe('.js-flow-timeline', blocks => {
    blocks.forEach(block => {
      // Create a new ImageNormalizerController
      const ImageNormalizer = new ImageNormalizerController();
      // Find all the logos in the block
      const logos = [...block.querySelectorAll('.js-flow-timeline__logo img')];
      // Add the images to the ImageNormalizer
      ImageNormalizer.add(logos);
      // Update the images
      ImageNormalizer.update();
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});